import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-[#FAF7F2] text-[#0A0A0A]" data-id="element-94">
      <div className="max-w-3xl mx-auto px-4" data-id="element-95">
        <motion.div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-96">
          <div className="bg-white p-4 rounded-full shadow-md" data-id="element-97">
            <ShieldCheck className="w-10 h-10 text-[#C5A55A]" data-id="element-98" />
          </div>
          <div data-id="element-99">
            <h3 className="text-xl font-bold font-serif mb-2" data-id="element-100">
              Compra con tranquilidad.
            </h3>
            <p className="text-[#555] leading-relaxed" data-id="element-101">
              Si participas y sientes que esta experiencia no era lo que tu
              relación necesitaba, escríbenos dentro de las primeras 24 horas y
              lo resolvemos contigo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}